const dotenv = require('dotenv');

dotenv.config();
const { REACT_APP_VALIDATION_MODE } = process.env;

const { isEmpty, validateType } = require('../helpers/index');
const { mandatory, maxLength, minLength } = require('./string');
const { uniqueFront } = require('./unique');
const { uniqueBack } = require('../serverSide/uniqueValidation');
const { maskedSchema } = require('../schemas');

const masks = (fieldValue, validation) => {
  const { value, message } = validation;
  if (!isEmpty(fieldValue)) {
    const executedMasks = value.map((mask) => {
      const re = new RegExp(mask.regex);
      return !!re.test(fieldValue);
    });

    const anyApplies = executedMasks.some((item) => item === true);
    const finalMessage = `${message} ${value.map((item) => item?.example).join(', ')}`;
    return !anyApplies ? finalMessage : undefined;
  }
  return undefined;
};

const isValidType = (fieldValue, validation) => {
  const { value, message } = validation;
  const currentValue = fieldValue;
  return value && !isEmpty(currentValue) && !validateType(currentValue, maskedSchema)
    ? message
    : undefined;
};

const unique = REACT_APP_VALIDATION_MODE !== undefined ? uniqueFront : uniqueBack;

module.exports = {
  isValidType,
  mandatory,
  masks,
  maxLength,
  minLength,
  unique,
};
